import axios from 'axios';
import { showMessage } from 'app/store/actions/fuse';
import { API_BASE_URL } from '@config';

export const SET_TWO_STEP_VERIFICATION_SETTINGS = 'SET_TWO_STEP_VERIFICATION_SETTINGS';
export const SET_TWO_STEP_VERIFICATION_ERROR = 'SET_TWO_STEP_VERIFICATION_ERROR';

export const setTwoStepVerificationSettings = (data) => ({
  type: SET_TWO_STEP_VERIFICATION_SETTINGS,
  payload: data,
});

export const setTwoStepVerificationError = (data) => ({
  type: SET_TWO_STEP_VERIFICATION_ERROR,
  payload: data,
});

export const getTwoStepVerificationSettings = (organizationId) => (dispatch) => {
  let url = `${API_BASE_URL}/api/two-step-verification/settings`;
  if (organizationId !== undefined && organizationId !== null) {
    url += `?organizationId=${organizationId}`;
  }
  return axios
    .get(url)
    .then((response) => {
      const { data, platformEnforcesAllTenants, emailConfigured } = response.data;
      const settings = {
        ...(data || {}),
        platformEnforcesAllTenants: !!platformEnforcesAllTenants,
        emailConfigured: !!emailConfigured,
      };
      dispatch(setTwoStepVerificationSettings(settings));
      return settings;
    })
    .catch((err) => {
      dispatch(setTwoStepVerificationError({ ...err.response, type: 'modal' }));
      throw err;
    });
};

export const updateTwoStepVerificationSettings = (settings, organizationId) => (dispatch) => {
  let url = `${API_BASE_URL}/api/two-step-verification/settings`;
  if (organizationId !== undefined && organizationId !== null) {
    url += `?organizationId=${organizationId}`;
  }

  const dataToSend = {
    enabled: settings.enabled,
    allowedDomains: settings.allowedDomains || '',
    requireForUsers: settings.requireForUsers,
  };
  // Platform doc, super admin only - the API rejects it anywhere else.
  if (settings.enforceAllTenants !== undefined) {
    dataToSend.enforceAllTenants = settings.enforceAllTenants;
  }

  return axios
    .put(url, dataToSend)
    .then(() => {
      dispatch(showMessage({ message: 'Two Step Verification settings updated successfully' }));
      dispatch(getTwoStepVerificationSettings(organizationId));
      return true;
    })
    .catch((err) => {
      const errorMsg = err.response?.data?.message || 'Error updating Two Step Verification settings';
      dispatch(setTwoStepVerificationError({ ...err.response, type: 'modal' }));
      dispatch(showMessage({ message: errorMsg, variant: 'error' }));
      throw err;
    });
};
